var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWakeupcall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29130",
    "data-name": "Group 29130",
    transform: "translate(-1447 -6767)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7696",
    "data-name": "Rectangle 7696",
    width: 64,
    height: 64,
    transform: "translate(1447 6767)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(1454 6767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36017",
    "data-name": "Path 36017",
    d: "M229.524,68a1.524,1.524,0,1,0,0,3.048h4.063a1.524,1.524,0,0,0,0-3.048Z",
    transform: "translate(-206.265 -59.873)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36018",
    "data-name": "Path 36018",
    d: "M186.416,13.188a5.579,5.579,0,0,0,2.271-4.5V8.571a1.525,1.525,0,0,1,1.524-1.524h6.095a1.525,1.525,0,0,1,1.524,1.524v.06a5.562,5.562,0,0,0,2.3,4.522,13.048,13.048,0,0,1,2.3-2.181,2.527,2.527,0,0,1-1.557-2.341v-.06A4.576,4.576,0,0,0,196.306,4h-6.095a4.576,4.576,0,0,0-4.571,4.571V8.69a2.535,2.535,0,0,1-1.507,2.319,13.1,13.1,0,0,1,2.283,2.179Z",
    transform: "translate(-167.968 -4)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36019",
    "data-name": "Path 36019",
    d: "M363.171,442.194a24.812,24.812,0,0,1-5.571,4.7l4.47,3.352a1.531,1.531,0,0,0,2.408-1.518Z",
    transform: "translate(-319.408 -386.553)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36020",
    "data-name": "Path 36020",
    d: "M101.294,442.194l-1.307,6.533a1.531,1.531,0,0,0,2.408,1.518l4.47-3.352A24.821,24.821,0,0,1,101.294,442.194Z",
    transform: "translate(-94.476 -386.553)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36021",
    "data-name": "Path 36021",
    d: "M313.885,56.563a1.524,1.524,0,0,0,.3,2.133l5.634,4.243-.885,1.206a24.753,24.753,0,0,1,2.51,1.73l.808-1.1,4.915,3.7a1.524,1.524,0,0,0,2.133-.3,10.086,10.086,0,0,0,2.246-6.524,8.7,8.7,0,0,0-2.759-5.79l1.056-1.438a1.524,1.524,0,1,0-2.457-1.8l-.99,1.351a8.873,8.873,0,0,0-6.861-1.368A10.088,10.088,0,0,0,313.885,56.563Z",
    transform: "translate(-280.977 -45.902)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36022",
    "data-name": "Path 36022",
    d: "M60.089,68.772a1.522,1.522,0,0,0,1.129-.292l4.914-3.7.808,1.1a24.75,24.75,0,0,1,2.51-1.73l-.885-1.206L74.2,58.7a1.524,1.524,0,0,0,.3-2.133,10.082,10.082,0,0,0-5.651-3.96,8.873,8.873,0,0,0-6.861,1.368L61,52.625a1.524,1.524,0,1,0-2.457,1.8L59.6,55.866a8.688,8.688,0,0,0-2.759,5.789,10.083,10.083,0,0,0,2.246,6.524A1.524,1.524,0,0,0,60.089,68.772Z",
    transform: "translate(-56.828 -45.907)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36023",
    "data-name": "Path 36023",
    d: "M98.634,107.607V104H95.586v3.607a23.11,23.11,0,1,0,3.048,0ZM97.11,148.443a17.777,17.777,0,1,1,17.777-17.777A17.8,17.8,0,0,1,97.11,148.443Z",
    transform: "translate(-71.82 -91.302)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36024",
    "data-name": "Path 36024",
    d: "M172.747,270.283a.762.762,0,0,0-1.078,0l-.718.718a2.288,2.288,0,0,1-3.232,0l-1.437-1.436a2.288,2.288,0,0,1,0-3.232l.718-.718a.762.762,0,0,0,0-1.077l-4.31-4.31a.762.762,0,0,0-1.077,0l-2.873,2.873c-.957.957-1.017,2.652-.169,4.772a20.135,20.135,0,0,0,4.478,6.362c3.223,3.223,6.652,5.079,9.021,5.079a2.881,2.881,0,0,0,2.113-.77l2.873-2.873a.762.762,0,0,0,0-1.077Z",
    transform: "translate(-145.133 -227.497)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36025",
    "data-name": "Path 36025",
    d: "M245.524,273.048a2.542,2.542,0,0,1,2.54,2.54,1.524,1.524,0,1,0,3.047,0A5.593,5.593,0,0,0,245.524,270a1.524,1.524,0,0,0,0,3.048Z",
    transform: "translate(-220.233 -236.224)",
    fill: "#003661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36026",
    "data-name": "Path 36026",
    d: "M245.524,222a1.524,1.524,0,0,0,0,3.047,8.644,8.644,0,0,1,8.635,8.635,1.524,1.524,0,0,0,3.048,0A11.7,11.7,0,0,0,245.524,222Z",
    transform: "translate(-220.233 -194.319)",
    fill: "#003661"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWakeupcall);
export default __webpack_public_path__ + "static/media/wakeupcall.61d385cc6cb990d83ce44f817262ee5a.svg";
export { ForwardRef as ReactComponent };